import { render, staticRenderFns } from "./categoriesView.vue?vue&type=template&id=7f6ba1bf&scoped=true"
import script from "./categoriesView.vue?vue&type=script&lang=js"
export * from "./categoriesView.vue?vue&type=script&lang=js"
import style0 from "./categoriesView.vue?vue&type=style&index=0&id=7f6ba1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ba1bf",
  null
  
)

export default component.exports